"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addChengPin = addChengPin;
exports.getMaterialChengPin = getMaterialChengPin;

var _request = _interopRequireDefault(require("@/utils/request"));

// 查询大家居成品物料（分页）
function getMaterialChengPin(params) {
  return (0, _request.default)({
    url: 'api/cmsCustBom/getMaterialChengPin',
    method: 'get',
    params: params
  });
} // 大家居成品物料下单


function addChengPin(data) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignSchemeAudit/addChengPin',
    method: 'post',
    data: data
  });
}